require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.0@core-js/library/modules/es7.symbol.observable.js
// module id = 159
// module chunks = 0